import { render } from "./FacialHarmonizationContentPtBR.vue?vue&type=template&id=437dedc8&scoped=true"
import script from "./FacialHarmonizationContentPtBR.vue?vue&type=script&lang=js"
export * from "./FacialHarmonizationContentPtBR.vue?vue&type=script&lang=js"

import "./FacialHarmonizationContentPtBR.vue?vue&type=style&index=0&id=437dedc8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-437dedc8"]])

export default __exports__